module.exports = __webpack_public_path__ + "img/首页未定栏目2.822aea64.jpg";